module.exports = __webpack_public_path__ + "img/scotland_icc.e02cedd1.png";